import React from "react";
import { Link, Typography } from "@mui/material/";
import { makeStyles } from "@mui/styles";
import styles from "./styles";

export default () => {
    const classes = makeStyles(styles)();
    return (
        <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            className={classes.copyRightContainer}
        >
            {"Powered by \u00a9 "}
            <Link
                color="text.primary"
                href="https://checkventory.com/"
                target="_blank"
            >
                CheckVentory
            </Link>
            {` ${new Date().getFullYear()}.`}
        </Typography>
    );
};
